import * as esriLoader from 'esri-loader';

type MCLayerConstructor = new (properties?: IMCLayerProperties) => IMCLayer;
interface IMCLayer extends __esri.BaseDynamicLayer {
    CategoryId: number;
    ColumnList: string;
    CreatedDate: Date;
    Description: string;
    FeatureSearchPriority: number;
    Filter: string;
    HoverColumnList: string;
    IsActive: boolean;
    IsSystem: boolean;
    IsFeatureSearchable: boolean;
    IsSearchable: boolean;
    LastEditedDate: Date;
    Name: string;
    SearchPriority: number;
    UniqueName: string;
    UserFilterObject: string;
}

interface IMCLayerProperties extends __esri.BaseDynamicLayerProperties {
    CategoryId?: number;
    ColumnList?: string;
    CreatedDate?: Date;
    Description?: string;
    FeatureSearchPriority?: number;
    Filter?: string;
    HoverColumnList?: string;
    IsActive?: boolean;
    IsSystem?: boolean;
    IsFeatureSearchable?: boolean;
    IsSearchable?: boolean;
    LastEditedDate?: Date;
    Name?: string;
    SearchPriority?: number;
    UniqueName?: string;
    UserFilterObject?: string;
}

class LayerExtender {
    public static async construct() {
        const [layer] = await esriLoader.loadModules(['esri/layers/BaseDynamicLayer'], window.esriConfig) as
            [__esri.BaseDynamicLayerConstructor];
        const MCMap = class extends layer implements IMCLayer {
            constructor(properties?: IMCLayerProperties) {
                super(properties);
                if (properties) {
                    this.CategoryId = properties.CategoryId;
                    this.ColumnList = properties.ColumnList;
                    this.CreatedDate = properties.CreatedDate;
                    this.Description = properties.Description;
                    this.FeatureSearchPriority = properties.FeatureSearchPriority;
                    this.Filter = properties.Filter;
                    this.HoverColumnList = properties.HoverColumnList;
                    this.IsActive = properties.IsActive;
                    this.IsSystem = properties.IsSystem;
                    this.IsFeatureSearchable = properties.IsFeatureSearchable;
                    this.IsSearchable = properties.IsSearchable;
                    this.LastEditedDate = properties.LastEditedDate;
                    this.Name = properties.Name;
                    this.SearchPriority = properties.SearchPriority;
                    this.UniqueName = properties.UniqueName;
                    this.UserFilterObject = properties.UserFilterObject;
                }
            }

            CategoryId: number;
            ColumnList: string;
            CreatedDate: Date;
            Description: string;
            FeatureSearchPriority: number;
            Filter: string;
            HoverColumnList: string;
            IsActive: boolean;
            IsSystem: boolean;
            IsFeatureSearchable: boolean;
            IsSearchable: boolean;
            LastEditedDate: Date;
            Name: string;
            SearchPriority: number;
            UniqueName: string;
            UserFilterObject: string;
        };
        return MCMap as MCLayerConstructor;
    }
}

export { LayerExtender, IMCLayer, IMCLayerProperties, MCLayerConstructor };
